/**
 * BidNova Card Imaging Studio — shared constants.
 *
 * Every listing image is normalised into the same studio frame so the
 * marketplace grid reads like a single photographic set: identical
 * backdrop, identical framing, identical card scale.
 */

/** Studio frame (4:5 portrait) used for every processed listing image. */
export const FRAME_W = 2400;
export const FRAME_H = 3000;

/** Fraction of the frame's short axis the card occupies. */
export const CARD_FILL = 0.75;

/** Rounded-corner radius as a fraction of the card's short edge. */
export const CARD_CORNER_RATIO = 0.035;

/** Derivative long-edge sizes (px). */
export const SIZE_DEEPZOOM = 3000; // deep-zoom master
export const SIZE_ULTRA = 2000; // 1600×2000 master
export const SIZE_PREVIEW = 1000; // 800×1000
export const SIZE_THUMB = 500; // 400×500


/** Hard ceiling on accepted source resolution. */
export const MAX_INPUT_EDGE = 12000;

/** Working resolution for the rectified card before compositing. */
export const RECTIFY_MAX_EDGE = 3400;

/** Accepted upload mime types (originals are never re-encoded). */
export const STUDIO_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/heic",
  "image/heif",
] as const;

export const STUDIO_EXTENSIONS = [
  "jpg",
  "jpeg",
  "png",
  "webp",
  "heic",
  "heif",
] as const;

/** 60MB — originals are stored raw, so the limit is generous. */
export const MAX_ORIGINAL_BYTES = 60 * 1024 * 1024;

export const BUCKET_ORIGINALS = "card-originals";
export const BUCKET_DERIVATIVES = "card-images";
